interface Props {
  documento: string;
  articulo: string;
  seccion: string;
  pagina: string;
  fragmento: string;
}

export default function NormativeSourceAccordion({
  documento,
  articulo,
  seccion,
  pagina,
  fragmento,
}: Props) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="px-3.5 py-3 space-y-2">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs">
          <div>
            <span className="text-foreground-400">Documento:</span>
            <p className="text-foreground-800 font-medium mt-0.5">{documento}</p>
          </div>
          <div>
            <span className="text-foreground-400">Artículo:</span>
            <p className="text-foreground-800 font-medium mt-0.5">{articulo}</p>
          </div>
          <div>
            <span className="text-foreground-400">Sección:</span>
            <p className="text-foreground-800 font-medium mt-0.5">{seccion}</p>
          </div>
          <div>
            <span className="text-foreground-400">Página:</span>
            <p className="text-foreground-800 font-medium mt-0.5">{pagina}</p>
          </div>
        </div>

        <div className="border-t border-background-200 pt-2.5">
          <p className="text-xs text-foreground-400 mb-1.5">Fragmento recuperado:</p>
          <blockquote className="text-sm text-foreground-700 leading-relaxed italic border-l-2 border-primary-300 pl-3 py-1 bg-white rounded-r">
            {fragmento}
          </blockquote>
        </div>

        <div className="flex items-center gap-1.5 text-xs text-accent-600 pt-1">
          <i className="ri-shield-check-line" />
          <span>Fuente verificada en documentos cargados</span>
        </div>
      </div>
    </div>
  );
}